import type { FOUNDER_DATA, FOUNDER_PARAMS } from './types'

export const DEFAULT_FOUNDER_DATA = (): FOUNDER_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'founder',
  name: 'Martina Pištěláková',
  role: 'Zakladatelka studia MARTINA DESIGN',
  quote: 'Celý život jsem sbírala know-how, které klienti dostávají až po dlouhé spolupráci. Klub jsem vytvořila proto, aby to měli k dispozici všichni.',
  stats: [
    { value: '12+', label: 'let praxe' },
    { value: '300+', label: 'projektů' },
  ],
  data: { document: null, hash: null, size: 'l', crop: 'structured-image-crop-none' },
})

export const DEFAULT_FOUNDER_PARAMS = (): FOUNDER_PARAMS => ({
  pc: { hidden: false },
  tablet: { hidden: false },
  mobile: { hidden: false },
})
